module.exports = __webpack_public_path__ + "img/pathgroup_2.5d0ffbdb.svg";